import { render, staticRenderFns } from "./VIndex.vue?vue&type=template&id=8e10847a&"
import script from "./VIndex.vue?vue&type=script&lang=js&"
export * from "./VIndex.vue?vue&type=script&lang=js&"
import style0 from "./VIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports